document.addEventListener("DOMContentLoaded", function (event) {
  const s_letters = "qwertyuiopasdfghjklzxcvbnm"; // Буквы в нижнем регистре
  const b_letters = "QWERTYUIOPLKJHGFDSAZXCVBNM"; // Буквы в верхнем регистре
  const digits = "0123456789"; // Цифры
  const specials = "!@#$%^&*()_-+=|/.,:;[]{}"; // Спецсимволы

  const modal_check = document.querySelector(".modal-check");
  const reg_password_input = document.getElementById("reg_password"); //получаем поле
  const reg_password_confirm_input = document.getElementById(
    "reg_password_confirm"
  );
  const modal_check_indicator = document.getElementById(
    "modal-check__indicator"
  ); //получаем блок с индикатором
  const modal_check__text = document.querySelector(".modal-check__text");
  if (reg_password_input) {
    reg_password_input.addEventListener("keyup", function (evt) {
      const reg_password_input_val = reg_password_input.value; //получаем значение из поля
      const reg_password_confirm_input_val = reg_password_confirm_input.value;

      passwordСomparison(
        reg_password_input_val,
        reg_password_confirm_input_val
      );

      if (reg_password_input_val.length) {
        modal_check.style.display = "flex";
      } else {
        modal_check.style.display = "none";
      }

      let is_s = false; // Есть ли в пароле буквы в нижнем регистре
      let is_b = false; // Есть ли в пароле буквы в верхнем регистре
      let is_d = false; // Есть ли в пароле цифры
      let is_sp = false; // Есть ли в пароле спецсимволы

      for (let i = 0; i < reg_password_input_val.length; i++) {
        /* Проверяем каждый символ пароля на принадлежность к тому или иному типу */
        if (!is_s && s_letters.indexOf(reg_password_input_val[i]) != -1) {
          is_s = true;
        } else if (
          !is_b &&
          b_letters.indexOf(reg_password_input_val[i]) != -1
        ) {
          is_b = true;
        } else if (!is_d && digits.indexOf(reg_password_input_val[i]) != -1) {
          is_d = true;
        } else if (
          !is_sp &&
          specials.indexOf(reg_password_input_val[i]) != -1
        ) {
          is_sp = true;
        }
      }

      let rating = 0;
      if (is_s) rating++; // Если в пароле есть символы в нижнем регистре, то увеличиваем рейтинг сложности
      if (is_b) rating++; // Если в пароле есть символы в верхнем регистре, то увеличиваем рейтинг сложности
      if (is_d) rating++; // Если в пароле есть цифры, то увеличиваем рейтинг сложности
      if (is_sp) rating++; // Если в пароле есть спецсимволы, то увеличиваем рейтинг сложности
      /* Далее идёт анализ длины пароля и полученного рейтинга, и на основании этого готовится текстовое описание сложности пароля */
      if (reg_password_input_val.length < 6 && rating < 3) {
        modal_check_indicator.style.width = "25%";
        modal_check_indicator.style.backgroundColor = "#D84C4C";
        modal_check__text.innerText = "Слабый пароль";
      } else if (reg_password_input_val.length < 6 && rating >= 3) {
        modal_check_indicator.style.width = "50%";
        modal_check_indicator.style.backgroundColor = "#EE8208";
        modal_check__text.innerText = "Средний пароль";
      } else if (reg_password_input_val.length >= 8 && rating < 3) {
        modal_check_indicator.style.width = "50%";
        modal_check_indicator.style.backgroundColor = "#EE8208";
        modal_check__text.innerText = "Средний пароль";
      } else if (reg_password_input_val.length >= 8 && rating >= 3) {
        modal_check_indicator.style.width = "100%";
        modal_check_indicator.style.backgroundColor = "#27AE60";
        modal_check__text.innerText = "Надежный пароль";
      } else if (reg_password_input_val.length >= 6 && rating == 1) {
        modal_check_indicator.style.width = "25%";
        modal_check_indicator.style.backgroundColor = "#D84C4C";
        modal_check__text.innerText = "Слабый пароль";
      } else if (
        reg_password_input_val.length >= 6 &&
        rating > 1 &&
        rating < 4
      ) {
        modal_check_indicator.style.width = "50%";
        modal_check_indicator.style.backgroundColor = "#EE8208";
        modal_check__text.innerText = "Средний пароль";
      } else if (reg_password_input_val.length >= 6 && rating == 4) {
        modal_check_indicator.style.width = "100%";
        modal_check_indicator.style.backgroundColor = "#27AE60";
        modal_check__text.innerText = "Надежный пароль";
      }
    });
  }

  // сравнение паролей
  if (reg_password_confirm_input) {
    reg_password_confirm_input.addEventListener("keyup", function (evt) {
      const reg_password_input_val = reg_password_input.value; //получаем значение из поля
      const reg_password_confirm_input_val = reg_password_confirm_input.value;

      passwordСomparison(
        reg_password_input_val,
        reg_password_confirm_input_val
      );
    });
  }

  // сравнивает введенные пароли
  function passwordСomparison(pass_1, pass_2) {
    const reg_password_confirm_label = document.querySelector(
      ".modal-reg__label[for='reg_password_confirm']"
    );
    if (pass_2.length) {
      if (pass_1 !== pass_2) {
        reg_password_confirm_label.classList.add("modal-reg__label--red");
      } else {
        reg_password_confirm_label.classList.remove("modal-reg__label--red");
      }
    }

    if (!pass_1.length && !pass_2.length) {
      reg_password_confirm_label.classList.remove("modal-reg__label--red");
    }
  }
});
